import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { cameraView02BowSpritImageOptions } from './views/CameraView02BowSprit'

class X49BowSprit extends Component {
    constructor(props) {
        super(props);
        this.handleBowspritChange = this.handleBowspritChange.bind(this);
    }


    handleBowspritChange(newValue) {
        let configuration = this.props.configuration;
        configuration.BowSprit = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = cameraView02BowSpritImageOptions;

        let image = <ConfiguratorImage boat="X4_9" configuration={this.props.configuration} options={imageOptions} />;
        
        return (
            <ConfiguratorSection image={image}>
                
                <ConfiguratorOption>
                    <h1><Trans defaults='Bowsprit' /></h1>

                    <p><Trans defaults='X49 Bowsprit Text' /></p>

                    <RadioGroup label={this.props.t("Optional bowsprits in hull colour:")} options={this.props.bowSpritOptions} value={this.props.configuration.BowSprit} onChange={this.handleBowspritChange} />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X49BowSprit);


// WEBPACK FOOTER //
// ./src/X49/X49BowSprit.js